// Pure builder for the canonical reader-doc shape used when auto-creating
// a stub reader on ARC apply, and by the queued backfill script. No
// Firestore imports here so the same builder can run under the modular
// client SDK (live applies) and under the Admin SDK (backfill).
//
// Caller passes the createdAt sentinel that suits their SDK:
//   - Client: serverTimestamp() from 'firebase/firestore'
//   - Admin:  admin.firestore.FieldValue.serverTimestamp()
//
// Shape mirrors the existing canonical create path in
// ReaderPortal.js (the readers/ useEffect that auto-creates on first
// sign-in). Keep the two in sync if the canonical shape ever moves.

export function buildReaderStub({
  authUid,
  email,
  name,
  authorId,
  source,
  createdAt,
}) {
  if (!authUid)   throw new Error('buildReaderStub: authUid required');
  if (!email)     throw new Error('buildReaderStub: email required');
  if (!authorId)  throw new Error('buildReaderStub: authorId required');
  if (!source)    throw new Error('buildReaderStub: source required');
  if (createdAt === undefined) throw new Error('buildReaderStub: createdAt required');

  const resolvedName = (name || email.split('@')[0] || '').trim();
  const today = new Date().toLocaleDateString();

  return {
    name: resolvedName,
    firstName: resolvedName.split(' ')[0] || '',
    lastName:  resolvedName.split(' ').slice(1).join(' ') || '',
    emailCorrespondence: email.toLowerCase(),
    status: 'Noted ARC interest',
    signupDate: today,
    selfSignupDate: today,
    totalPoints: 0,
    authUid,
    createdAt,
    source,
    authorId,
    shippingAddress: { line1: '', line2: '', city: '', postalCode: '', country: '' },
    socialMedia:     { instagram: '', tiktok: '', goodreads: '', amazon: '', other: '' },
    preferences:     { favoriteGenres: [], favoriteTropes: '' },
  };
}
